<template>
	<div class="min-h-screen">
		<UINav v-motion-slide-top :dark="dark" />
		<slot />
	</div>
	<UIFooter />
</template>

<script setup lang="ts">
const dark = computed(() => {
	return useRoute().path === '/' || useRoute().path === '/lineup'
})
</script>

<style scoped></style>
